const FormId = '1';
const Aborted = 'Aborted';
const Completed = 'Completed';
const PaneCompleted = 'Pane Completed';
const PaneAborted = 'Pane Aborted';
const FeedbackCompleted = 'Feedback Completed';
const FeedbackAborted = 'Feedback Aborted';
const FeedbackCategory = 'Feedback';
export function feedbackAppEventParam(paneId, isCompleted, label) {
    return ({
        formId: FormId,
        endType: isCompleted ? Completed : Aborted,
        feedback: [{
                paneId,
                value: {
                    action: isCompleted ? PaneCompleted : PaneAborted,
                    category: FeedbackCategory,
                    label: label,
                    value: paneId,
                },
            }, {
                paneId,
                value: {
                    action: isCompleted ? FeedbackCompleted : FeedbackAborted,
                    category: FeedbackCategory,
                },
            }],
    });
}
